<div class="quantity">
  @if (!showTrashBin || value > min) {
    <div class="select-AddOns-Quantity-minus" [ngClass]="{'disabled': value === min}" (click)="handleMinus()">
      @if (useOutline) {
        <mat-icon>remove_circle_outline</mat-icon>
      } @else {
        <mat-icon>remove_circle</mat-icon>
      }
    </div>
  }

  <div class="quantity__number">
    {{ value }}
  </div>

  <div class="select-AddOns-Quantity-plus" [ngClass]="{'disabled': value === max}" (click)="handleAdd()">
    @if (useOutline) {
      <mat-icon>add_circle_outline</mat-icon>
    } @else {
      <mat-icon>add_circle</mat-icon>
    }
  </div>
</div>